module.exports = __webpack_public_path__ + "static/contact-main-1de0af6af3ca6ac879f81675502b8660.png";